import LTR from "@brand-icons/ploom/ui-help-circle/ui-help-circle-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiHelpCircleIcon = iconFactory("UiHelpCircleIcon", LTR);
